import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { RetailCartProvider } from "./contexts/RetailCartContext";
import { ConfigProvider } from "./contexts/ConfigContext";
import { Layout } from "./components/Layout";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import WholesaleApply from "./pages/WholesaleApply";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Portal, { CheckoutSuccess } from "./pages/Portal";
import RetailCart, { RetailSuccess } from "./pages/RetailCart";
import Invite from "./pages/Invite";
import Admin from "./pages/Admin";
import Club, { ClubSuccess } from "./pages/Club";
import CandyRequest from "./pages/CandyRequest";
import OrdersLookup from "./pages/OrdersLookup";

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <CartProvider>
          <RetailCartProvider>
            <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/shop" element={<Layout><Shop /></Layout>} />
              <Route path="/catalog" element={<Layout><Shop /></Layout>} />
              <Route path="/cart" element={<Layout><RetailCart /></Layout>} />
              <Route path="/shop/success" element={<Layout><RetailSuccess /></Layout>} />
              <Route path="/product/:id" element={<Layout><ProductDetail /></Layout>} />
              <Route path="/wholesale" element={<Layout><WholesaleApply /></Layout>} />
              <Route path="/contact" element={<Layout><Contact /></Layout>} />
              <Route path="/login" element={<Layout><Login /></Layout>} />
              <Route path="/register" element={<Layout><Register /></Layout>} />
              <Route path="/portal" element={<Layout><Portal /></Layout>} />
              <Route path="/portal/success" element={<Layout><CheckoutSuccess /></Layout>} />
              <Route path="/invite" element={<Layout><Invite /></Layout>} />
              <Route path="/admin" element={<Layout><Admin /></Layout>} />
              <Route path="/club" element={<Layout><Club /></Layout>} />
              <Route path="/club/success" element={<Layout><ClubSuccess /></Layout>} />
              <Route path="/request" element={<Layout><CandyRequest /></Layout>} />
              <Route path="/orders" element={<Layout><OrdersLookup /></Layout>} />
              <Route path="/orders/lookup" element={<Layout><OrdersLookup /></Layout>} />
            </Routes>
            </BrowserRouter>
          </RetailCartProvider>
        </CartProvider>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
